import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobanglorecab() {



  const cardData =
  {
    keyword: 'Pune to Bangalore Cab Fare',
    heading: 'Sanavi Travels: Pune to Bangalore Cab Fare',
    headingDescription: 'Sanavi Travels provides reliable Pune to Bangalore Cab Fare services, offering safe, comfortable, and hassle-free transportation for families, corporate travelers, tourists, and groups traveling from Pune to Bangalore. Our fleet of sedans, SUVs, and luxury cabs is well-maintained with spacious seating, air-conditioning, and ample luggage space, ensuring a smooth and enjoyable long-distance journey. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, reliable, and stress-free travel. We offer convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering key Bangalore attractions and routes. Choose Sanavi Travels for trusted Pune to Bangalore cab services, delivering comfort, safety, and a seamless outstation travel experience at competitive fares.',

    top: 'Top Places to Visit in Bangalore with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace is a grand 19th-century palace inspired by England’s Windsor Castle. Known for its Tudor-style architecture, fortified towers, and lavish interiors, it showcases antique furniture, paintings, and royal memorabilia. It’s a must-visit for history and architecture enthusiasts."
  },
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is a sprawling garden spanning over 240 acres, famous for its glasshouse, exotic plant species, and annual flower shows. Visitors enjoy serene walks, photography, and exploring centuries-old trees and landscaped gardens."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park is a lush green urban park in the heart of Bangalore, ideal for morning walks, jogging, and relaxation. It houses statues, a bandstand, and diverse flora, providing a peaceful escape from the city’s bustle."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is an iconic government building and one of Bangalore’s architectural landmarks. Built in Neo-Dravidian style, it houses the state legislature and secretariat. Its grand facade and majestic structure make it a popular tourist attraction."
  },
  {
    "title": "ISKCON Temple",
    "description": "The ISKCON Temple in Bangalore is a modern spiritual complex dedicated to Lord Krishna. It features beautiful architecture, serene gardens, and daily rituals. Visitors can participate in devotional activities, enjoy cultural programs, and relish vegetarian cuisine at the temple’s restaurant."
  },
  {
    "title": "Nandi Hills",
    "description": "Nandi Hills is a scenic hill station near Bangalore, popular for sunrise views, trekking, and historical forts. Surrounded by lush greenery, it offers panoramic views, cool climate, and a peaceful escape from the city."
  },
  {
    "title": "Bannerghatta National Park",
    "description": "Bannerghatta National Park is a wildlife sanctuary near Bangalore, featuring a zoo, safari park, butterfly park, and trekking trails. Visitors can observe tigers, lions, elephants, and other wildlife in naturalistic settings."
  },
  {
    "title": "Tipu Sultan’s Summer Palace",
    "description": "Tipu Sultan’s Summer Palace is a historic palace in Bangalore, known for its Indo-Islamic architecture, ornate arches, and teakwood pillars. It showcases artifacts and paintings from Tipu Sultan’s era, reflecting the city’s royal history."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is one of Bangalore’s busiest shopping areas, offering clothes, jewelry, handicrafts, and street food. It’s a vibrant destination for tourists and locals seeking shopping, food, and cultural experiences."
  },
  {
    "title": "Ulsoor Lake",
    "description": "Ulsoor Lake is a large and serene lake in Bangalore, ideal for boating and leisurely walks. Surrounded by gardens and small islands, it provides a peaceful setting for relaxation and photography within the city."
  }
]
,




"services": [
  {
    "name": "Pune to Bangalore Cab Fare",
    "description": "Pune to Bangalore Cab Fare provides passengers with clear and transparent pricing for long-distance travel. Fully air-conditioned vehicles with spacious seating and ample luggage space ensure a comfortable journey. Professional chauffeurs handle route planning, traffic, and pickups, making the long journey stress-free. Ideal for families, corporate travelers, and groups, this service prioritizes affordability, comfort, and reliability on Pune to Bangalore trips."
  },
  {
    "name": "Pune Bangalore Cab Service",
    "description": "Pune Bangalore Cab Service offers a dependable and convenient travel solution for individuals and groups traveling between Pune and Bangalore. Air-conditioned vehicles with professional chauffeurs ensure a smooth, safe, and timely journey. Suitable for one-way trips, round trips, corporate travel, or family vacations, this service guarantees comfort, safety, and a hassle-free long-distance experience."
  },
  {
    "name": "AC Cab Pune to Bangalore",
    "description": "AC Cab Pune to Bangalore ensures a cool and comfortable journey for long-distance travel. Fully air-conditioned vehicles with spacious seating and ample luggage space make the trip pleasant, even in hot weather. Experienced chauffeurs manage navigation, traffic, and timings efficiently. Ideal for families, corporate groups, or solo travelers seeking comfort, convenience, and reliability on Pune to Bangalore routes."
  },
  {
    "name": "Luxury Cab Bangalore Trip",
    "description": "Luxury Cab Bangalore Trip provides a premium travel experience with stylish, fully air-conditioned vehicles equipped with modern amenities. Perfect for families, couples, or corporate travelers seeking high-end travel, this service ensures safety, comfort, and punctuality. Professional chauffeurs handle navigation and traffic, allowing passengers to relax and enjoy a hassle-free journey from Pune to Bangalore."
  },
  {
    "name": "Family Cab Bangalore",
    "description": "Family Cab Bangalore is designed for families traveling from Pune to Bangalore. Spacious cabs with air-conditioning, luggage space, and comfortable seating ensure a relaxing journey. Experienced drivers provide safe navigation, punctual pickups, and smooth rides. Ideal for vacations, weekend getaways, or long trips, this service prioritizes family comfort, convenience, and reliability."
  },
  {
    "name": "Outstation Cab Bangalore",
    "description": "Outstation Cab Bangalore provides reliable long-distance transport from Pune to Bangalore. Fully air-conditioned vehicles with professional chauffeurs ensure a smooth and secure journey. Suitable for families, corporate groups, or solo travelers, the service supports flexible travel plans including one-way or round trips, making outstation travel convenient and comfortable."
  },
  {
    "name": "Affordable Cab Bangalore",
    "description": "Affordable Cab Bangalore offers budget-friendly travel without compromising on safety or comfort. Air-conditioned vehicles with professional chauffeurs provide a smooth, reliable, and convenient journey from Pune to Bangalore. Ideal for students, families, and group travelers seeking economical long-distance travel."
  },
  {
    "name": "Chauffeur Driven Cab Bangalore",
    "description": "Chauffeur Driven Cab Bangalore ensures a stress-free and professional journey from Pune to Bangalore. Experienced drivers manage navigation, traffic, and route planning while passengers enjoy spacious, air-conditioned vehicles with ample luggage space. Suitable for families, groups, corporate travelers, or solo tourists seeking comfort, safety, and punctuality on long-distance trips."
  },
  {
    "name": "Best Cab Pune to Bangalore",
    "description": "Best Cab Pune to Bangalore provides a premium travel experience with fully air-conditioned, well-maintained vehicles. Professional chauffeurs ensure safe, timely, and reliable long-distance travel. Ideal for families, corporate travelers, groups, or solo passengers, this service guarantees a smooth, comfortable, and hassle-free Pune to Bangalore journey."
  },
  {
    "name": "Pune Bangalore Taxi",
    "description": "Pune Bangalore Taxi is a dependable solution for long-distance travel between Pune and Bangalore. Spacious, air-conditioned vehicles with professional chauffeurs ensure comfort, safety, and reliability. Flexible pickup and drop-off options make it suitable for families, corporate travelers, or groups seeking convenient travel."
  },
  {
    "name": "Long Distance Cab Pune",
    "description": "Long Distance Cab Pune specializes in safe, comfortable, and reliable travel for long routes like Pune to Bangalore. Air-conditioned vehicles with experienced chauffeurs provide a stress-free journey. Ideal for family trips, corporate travel, or leisure excursions, this service ensures convenience, comfort, and punctuality."
  },
  {
    "name": "One Way Cab Bangalore",
    "description": "One Way Cab Bangalore offers a convenient, cost-effective, and comfortable travel option for passengers traveling from Pune to Bangalore without a return trip. Fully air-conditioned vehicles with professional chauffeurs ensure a safe, timely, and hassle-free journey, suitable for families, groups, or solo travelers."
  },
  {
    "name": "Round Trip Cab Bangalore",
    "description": "Round Trip Cab Bangalore provides a flexible solution for travelers planning to return to Pune after visiting Bangalore. Fully air-conditioned, well-maintained vehicles with professional chauffeurs ensure a comfortable, safe, and timely round trip. Ideal for families, corporate travel, or group tours, this service combines reliability and convenience for long-distance journeys."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune allows travelers to book Pune to Bangalore cabs easily from anywhere, anytime. Passengers can select vehicle type, pickup and drop locations, date, and trip duration with instant confirmation. Fully air-conditioned vehicles with professional chauffeurs provide a safe, comfortable, and timely journey, making online booking convenient, reliable, and stress-free."
  },
  {
    "name": "Bangalore Travel Cab",
    "description": "Bangalore Travel Cab offers a dependable and comfortable option for exploring Bangalore after traveling from Pune. Fully air-conditioned vehicles with spacious seating and professional chauffeurs ensure a smooth, safe, and enjoyable journey. Suitable for sightseeing, family trips, or corporate travel, this service guarantees comfort, convenience, and reliability throughout the Pune-Bangalore trip."
  }
],
"tableData": [
  ["Pune to Bangalore Cab Fare", "Pune Bangalore Cab Service"],
  ["AC Cab Pune to Bangalore", "Luxury Cab Bangalore Trip"],
  ["Family Cab Bangalore", "Outstation Cab Bangalore"],
  ["Affordable Cab Bangalore", "Chauffeur Driven Cab Bangalore"],
  ["Best Cab Pune to Bangalore", "Pune Bangalore Taxi"],
  ["Long Distance Cab Pune", "One Way Cab Bangalore"],
  ["Round Trip Cab Bangalore", "Online Cab Booking Pune"],
  ["Bangalore Travel Cab", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Bangalore Cab Fare with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers affordable and transparent cab fares for travel from Pune to Bangalore, perfect for family trips, corporate travel, and long-distance journeys."
  },
  {
    "WhyChooseheading": "Competitive and Clear Pricing",
    "WhyChoosedescription": "Get upfront and competitive Pune to Bangalore cab fares with no hidden charges—fuel, tolls, and driver allowances included for peace of mind."
  },
  {
    "WhyChooseheading": "Comfortable and Well‑Maintained Cabs",
    "WhyChoosedescription": "Travel in air‑conditioned, clean, and regularly serviced vehicles to ensure a smooth and enjoyable journey from Pune to Bangalore."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are familiar with long‑distance routes, ensuring safe, punctual, and hassle‑free travel."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with fare queries, bookings, travel planning, and itinerary changes."
  },
  {
    "WhyChooseheading": "Flexible Travel Options",
    "WhyChoosedescription": "Choose the best travel package—one‑way, round‑trip, or customized Pune to Bangalore cab plans that fit your schedule and budget."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every trip to ensure passenger safety and comfort."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Bangalore cab travel."
  }
]

}

const faqData = [
  {
    question: 'What is the cab fare from Pune to Bangalore with Sanavi Travels?',
    answer: 'Cab fares vary based on the type of vehicle selected, travel date, and trip duration. You can get an instant fare quote by booking online or contacting our support team.'
  },
  {
    question: 'Does the Pune to Bangalore fare include tolls and fuel?',
    answer: 'Yes, Sanavi Travels provides transparent fare quotes that include fuel, tolls, and driver allowances with no hidden charges.'
  },
  {
    question: 'Can I choose different cab types for Pune to Bangalore travel?',
    answer: 'Yes, we offer a variety of vehicles including sedans, SUVs, and premium cars to match your travel needs and budget.'
  },
  {
    question: 'Is the Pune to Bangalore cab service available 24x7?',
    answer: 'Yes, you can book a cab any time of the day or night for travel from Pune to Bangalore.'
  },
  {
    question: 'How can I get an accurate fare estimate?',
    answer: 'You can get a precise fare estimate by entering your trip details on our website or contacting our 24x7 customer support team.'
  },
  {
    question: 'Are there any hidden charges added later?',
    answer: 'No, Sanavi Travels provides upfront pricing with no hidden charges—your fare quote includes all essential costs.'
  },
  {
    question: 'Can I customize my Pune to Bangalore cab package?',
    answer: 'Absolutely. We offer customized travel plans based on your specific travel requirements and preferences.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during my journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip to assist you.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Iyer',
    feedback: 'Booked a Pune to Bangalore cab with Sanavi Travels. The fare was very reasonable, and the journey was comfortable and smooth.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Shalini Rao',
    feedback: 'Excellent service! The cab was clean, the driver was professional, and the pricing was transparent. Highly recommend Sanavi Travels.',
    rating: 5
  }
];






















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bangalore Cab Service - Sanavi Travels",
  "description": "Book Pune to Bangalore cabs with Sanavi Travels. AC and luxury cabs for family trips, outstation journeys, long-distance travel, one-way or round trips, tourist trips, and comfortable chauffeur-driven service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Pune to Bangalore Cab Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury cabs from Pune to Bangalore with Sanavi Travels. Ideal for family trips, outstation journeys, long-distance travel, one-way or round trips, tourist trips, and safe chauffeur-driven service."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/64.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetobanglorecab;